// src/push-notification.js
import { /* messaging, */ messagingPromise, getToken, onMessage } from './firebase-config';
import { decryptData } from './utils/storageCrypto';

/* export async function requestPermission() {
    try {
        const permission = await Notification.requestPermission();
        // Check if the browser supports notifications
if ("Notification" in window) {
    // Request permission to send notifications
    Notification.requestPermission().then(function(permission) {
        if (permission === "granted") {
            console.log("Notification permission granted.");
        } else {
            console.log("Notification permission denied.");
        }
    });
} else {
    console.log("This browser does not support notifications.");
}

        console.log(permission)
        if (permission === "granted") {
            console.log("Notification permission granted.");
            getFCMToken();
        } else {
            console.log("Notification permission denied.");
        }
    } catch (error) {
        console.error("Error requesting notification permission: ", error);
    }
}

console.log("Notification permission:", Notification.permission); */


export async function requestPermission() {
    try {
        if (!("Notification" in window)) {
            console.log("This browser does not support notifications.");
            return;
        }

        const permission = await Notification.requestPermission();
        console.log("Notification permission:", permission);

        if (permission === "granted") {
            console.log("Notification permission granted.");
            getFCMToken();
        } else {
            console.log("Notification permission denied.");
        }
    } catch (error) {
        console.error("Error requesting notification permission: ", error);
    }
}



async function getFCMToken() {
    //console.log("entered get fcm token");
    try {

        const messaging = await messagingPromise;
        if (!messaging) {
            console.log("FCM not supported.");
            return;
        }

        const token = await getToken(messaging, {
            vapidKey: "BFh9eSQS_pwCm_jvZZZIi40lmhbuaFaSbFCTP6djVQfKKvDc_fEEy0-AoejE8-IAu-WsykVBG644O3SCH0zhz_s"
        });
        sessionStorage.setItem('fcmtoken', token);
        const enuserId = sessionStorage.getItem('userId')
        console.log(enuserId);
        const uId = decryptData(enuserId);
        console.log(uId)
        const endpId = sessionStorage.getItem('dpId');
        const dpId = decryptData(endpId);
        //console.log("FCM Token retrieved:", token); // Ensure this log is executed

        if (
        token &&
        (
            /* sessionStorage.getItem('userId') */uId ||
            sessionStorage.getItem('customerId') ||
            sessionStorage.getItem('vendorId') ||
            /* sessionStorage.getItem('dpId') */ dpId
        )
        ) {
           // console.log("FCM Token:", token);
/*            const enuserId = sessionStorage.getItem('userId')
           const uId = decryptData(enuserId); */
           const enroleId = sessionStorage.getItem('roleId')
           const s_roleId = decryptData(enroleId);
            const userId = /* sessionStorage.getItem('userId') */ uId ||
            sessionStorage.getItem('customerId') ||
            sessionStorage.getItem('vendorId') || dpId;
            /* sessionStorage.getItem('dpId'); */
            const roleId = s_roleId || sessionStorage.getItem('roleId');
            await sendTokenToBackend(token,userId,roleId);
        } else {
            console.log("No registration token available.");
        }
    } catch (error) {
        console.error("Error getting FCM token: ", error); // Log the error if it fails
    }
}




async function sendTokenToBackend(token,userId,roleId) {
    // Use fetch or axios to send the token to your backend (example API endpoint)
    await fetch(`${process.env.REACT_APP_FORE_NOTIFY}register-fcm-token`, {
        method: "POST",
        body: JSON.stringify({ token,userId,roleId }),
        headers: { "Content-Type": "application/json" }
    });
}

/* // Handling foreground notifications
export function handleForegroundNotifications() {
    onMessage(messaging, (payload) => {
        //console.log("Message received: ", payload);
        alert(payload.notification.title + "\n\n" + payload.notification.body);
        // Handle the notification here (show UI, etc.)
    });
} */

    //latest
/* export const handleForegroundNotifications = (setNotifications) => {
    messagingPromise.then((messaging) => {
        if (messaging) {
            onMessage(messaging, (payload) => {
                console.log('🔔 Foreground notification received:', payload);
                
                // Combine notification and data into one object
                const newNotification = {
                    title: payload.notification?.title,
                    body: payload.notification?.body,
                    data: payload.data || {},
                };
                console.log('newNotification', newNotification)

                setNotifications(prev => [...prev, newNotification]);
            });
        } else {
            console.warn('Messaging not supported in this browser.');
        }
    }).catch((error) => {
        console.error('Failed to initialize Firebase messaging:', error);
    });
}; */

// Add a flag to prevent multiple listeners
let isListenerRegistered = false;

//without user verification
/* export const handleForegroundNotifications = (setNotifications) => {
    if (isListenerRegistered) {
        //console.log('Notification listener already registered');
        return;
    }

    messagingPromise.then((messaging) => {
        if (messaging) {
            onMessage(messaging, (payload) => {
                console.log('🔔 Foreground notification received:', payload);
                
                // Combine notification and data into one object
                const newNotification = {
                    title: payload.notification?.title,
                    body: payload.notification?.body,
                    data: payload.data || {},
                    timestamp: new Date().toISOString() // Add timestamp for uniqueness
                };
                console.log('newNotification', newNotification);

                const updateNotifications = (prev, newNotification) => {
    console.log('Previous notifications:', prev);
    const updated = [...prev, newNotification];
    console.log('Updated notifications:', updated);
    return updated;
};
 //console.log('updateNotifications', updateNotifications);
// Then in your usage:
setNotifications(prev => updateNotifications(prev, newNotification));
            });
            isListenerRegistered = true;
            //console.log('Firebase messaging listener registered successfully');
        } else {
            console.warn('Messaging not supported in this browser.');
        }
    }).catch((error) => {
        console.error('Failed to initialize Firebase messaging:', error);
    });
}; */

//with user verification
export const handleForegroundNotifications = (setNotifications) => {
    if (isListenerRegistered) {
        //console.log('Notification listener already registered');
        return;
    }

    messagingPromise.then((messaging) => {
        if (messaging) {
            onMessage(messaging, (payload) => {
                console.log('🔔 Foreground notification received:', payload);
                
                // Get the current user ID from localStorage/sessionStorage
                const currentUserId = //localStorage.getItem('userId') || 
                                    sessionStorage.getItem('userId') ||
                                    //localStorage.getItem('customerId') || 
                                    sessionStorage.getItem('customerId') ||
                                    //localStorage.getItem('vendorId') || 
                                    sessionStorage.getItem('vendorId') ||
                                    sessionStorage.getItem('dpId');
                
                // Get recipient ID from notification data
                const recipientId = payload.data?.recipientId || payload.data?.recipient_id;
                
                console.log('Current User ID:', currentUserId);
                console.log('Notification Recipient ID:', recipientId);
                
                // Only process notification if recipient matches current user
                if (currentUserId && recipientId && currentUserId === recipientId) {
                    // Combine notification and data into one object
                    const newNotification = {
                        title: payload.notification?.title,
                        body: payload.notification?.body,
                        data: payload.data || {},
                        timestamp: new Date().toISOString() // Add timestamp for uniqueness
                    };
                    console.log('newNotification', newNotification);

                    const updateNotifications = (prev, newNotification) => {
                        console.log('Previous notifications:', prev);
                        const updated = [...prev, newNotification];
                        console.log('Updated notifications:', updated);
                        return updated;
                    };
                    
                    // Update notifications only for matching recipient
                    setNotifications(prev => updateNotifications(prev, newNotification));
                } else {
                    console.log('Notification not for current user, ignoring...');
                }
            });
            isListenerRegistered = true;
            //console.log('Firebase messaging listener registered successfully');
        } else {
            console.warn('Messaging not supported in this browser.');
        }
    }).catch((error) => {
        console.error('Failed to initialize Firebase messaging:', error);
    });
};

/* export function handleForegroundNotifications(messaging) {
    onMessage(messaging, (payload) => {
        console.log("Foreground message received:", payload);

        const { title, body } = payload.notification || {};

        if (title && body) {
            // For example, using an alert for demo:
            alert(`Notification: ${title}\n${body}`);
        } else {
            alert("You received a new message");
        }

        // Optionally, show custom UI notification instead of alert()
        // showCustomNotification(title, body);
    });
} */